import React from "react";
import Linkify from "react-linkify";

const TextMessage = props => {
  const { data, author, creationDate, displayName } = props;
  return (
    <>
      <div
        className="sc-message--text"
        style={{
          backgroundColor: author === "me" ? "var(--primary-color)" : "#F2F2F2"
        }}
      >
        <div>
          {<Linkify properties={{ target: "_blank" }}>{data.text}</Linkify>}
        </div>
        <span className="date-line d-flex" />
        <div className="date-name-display">
          {creationDate} {displayName}
        </div>
      </div>

      <div />
    </>
  );
};

export default TextMessage;
